
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';
import moment from 'moment';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private dayTypes! : any;

  private limitDate = moment(ReservationItemModule.form.possiableUpdateDate);

  private isUpdate = false;

  private updateSchedule = {};

  get updateScheduleDate() {
    this.setData();
    return ReservationItemModule.updateScheduleDate;
  }

  get scheduleType() {
    this.setData();
    return ReservationItemModule.scheduleType;
  }

  get isNew() {
    return ReservationItemModule.isNew;
  }

  get formData() {
    return ReservationItemModule.form;
  }

  private setData() {
    if (ReservationItemModule.scheduleType === null && ReservationItemModule.updateScheduleDate !== '0') {
      this.updateSchedule = ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1];
      this.isUpdate = !this.limitDate.isAfter(ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].updateDate);
      console.debug('isUpdate', this.isUpdate);
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate === '0') {
      this.updateSchedule = ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType];
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate !== '0') {
      this.updateSchedule = ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1];
      this.isUpdate = !this.limitDate.isAfter(ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].updateDate);
    }
  }

  private showTimeSchedule(data: any) {
    this.$emit('showTimeSchedule', data);
  }

  private handleTryUpdate() {
    if (!this.isUpdate && !this.isNew) {
      this.$message('일정 업데이트 기능을 통해 수정이 가능합니다.');
    }
  }
}
